import { RouteObject } from 'react-router';

export const mastersRoutes: RouteObject[] = [
    {
        path: 'masters',
        lazy: () => import('./masters-settings-page'),
        handle: { customDashboardLayout: true },
        children: [
            {
                index: true,
                lazy: () => import('./pages/status-labels-page'),
            },
            {
                path: 'status-labels',
                lazy: () => import('./pages/status-labels-page'),
            },
            {
                path: 'asset-models',
                lazy: () => import('./pages/asset-models-page'),
            },
            {
                path: 'categories',
                lazy: () => import('./pages/categories-page'),
            },
            {
                path: 'manufacturers',
                lazy: () => import('./pages/manufacturers-page'),
            },
            {
                path: 'suppliers',
                lazy: () => import('./pages/suppliers-page'),
            },
            {
                path: 'departments',
                lazy: () => import('./pages/departments-page'),
            },
            {
                path: 'locations',
                lazy: () => import('./pages/locations-page'),
            },
            {
                path: 'companies',
                lazy: () => import('./pages/companies-page'),
            },
            {
                path: 'depreciation',
                lazy: () => import('./pages/depreciation-page'),
            },
            {
                path: 'priority',
                lazy: () => import('./pages/priority-page'),
            },
            {
                path: 'purpose',
                lazy: () => import('./pages/purpose-page'),
            },
            {
                path: 'reason',
                lazy: () => import('./pages/reason-page'),
            },
            {
                path: 'request-mode',
                lazy: () => import('./pages/request-mode-page'),
            },
            {
                path: 'ticket-status',
                lazy: () => import('./pages/ticket-status-page'),
            },
        ],
    },
];
